import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6949ad43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-tabs" }
const _hoisted_2 = {
  key: 1,
  class: "name"
}

import { onBeforeMount, onMounted, useSlots, reactive, VNode, provide } from 'vue';
  import _ from 'lodash';

  export interface IState {
    selectedIndex: number;
    count: number;
    tabs: VNode<any>[]
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const slots = useSlots();
  const state = reactive<IState>({
    selectedIndex: 0,
    tabs: [] as VNode<any>[],
    count: 0
  });

  provide('TabsProvider', state);

  const selectTab = (i: number) => {
    state.selectedIndex = i;
  };

  onBeforeMount(() => {
    if (slots.default) {
      const defaults = slots.default();
      // for 循环的appTab default slot type是symbol
      const nodes = typeof defaults[0].type === 'symbol' ? defaults[0].children : defaults;
      state.tabs = ((nodes || []) as Array<any>).filter((child: any) => _.get(child, 'type.name') === 'AppTab');
    }
  });

  onMounted(() => {
    selectTab(0);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["box-tab-items", [`active-${_unref(state).selectedIndex}`]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tabs, (item, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(item.props?.href ? 'a' : 'div'), _mergeProps({
          key: index,
          class: ["tab-item", { active: index === _unref(state).selectedIndex, [`tab-item-${index}`]: true }]
        }, item.props?.href ? item.props : {
            onClick: () => selectTab(index),
            ...item.props
          }), {
          default: _withCtx(() => [
            (_unref(slots).trigger)
              ? _renderSlot(_ctx.$slots, "trigger", _normalizeProps(_mergeProps({ key: 0 }, { active: index === _unref(state).selectedIndex, label: item.props?.label, index })))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.props?.label), 1))
          ]),
          _: 2
        }, 1040, ["class"]))
      }), 128))
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})